import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import WithRender from '@/Pages/Admin/Modules/ManageUsers/Profile/Contacts/Views/contact-profile.html';
import {common} from '@/Pages/Admin/Modules/Common/Services/Common';
import ValidationError from '@/Pages/Admin/Modules/Common/Controllers/ValidationError';
import {trekService} from '@/Pages/Admin/Modules/ManagePackage/Services/Trekservice';
import {flashService} from '@/Pages/Admin/Modules/Common/Services/FlashMessage/FlashService';
import {UserModel} from '@/Pages/Admin/Modules/Models/ManageAccount/UserModel';
import {AccountModel} from '@/Pages/Admin/Modules/Models/ManageAccount/AccountModel';

@WithRender
@Component({
    components: {
        'validation-error': ValidationError
    }
})
export default class ContactProfile extends Vue {
    protected ui: any = {};
    protected item: any = {};
    protected vars: any = {};

    constructor() {
        super();

        this.ui = {
            status: {
                isLoading: {
                    getUserProfile: false,
                },
                postLoading: {
                    editProfile: false,
                },
                editProfile: false,
            },
            error: {
                errors: {},
                has_error: false,
                error_message: {},
            },
        };

        this.item = {
            userData: new UserModel({}),
            tempUserData: new UserModel({}),
            accountData: new AccountModel({}),
            tempAccountData: new AccountModel({}),
        };
    }

    public created() {
        this.getUserInfo();
    }

    public getUserInfo() {
        this.ui.status.isLoading.getUserProfile = true;
        trekService
            .userDataRetrieve()
            .then((res: any) => {
                this.item.userData = res.data.data;
                this.item.accountData = res.data.data.account_user.account;
            })
            .catch((error: any) => {
                common.sdCatchErr(error, this.ui.error.error_message).then(res => {
                    this.ui.error.error_message = res;
                });
            })
            .finally(() => {
                this.ui.status.isLoading.getUserProfile = false;
            });
    }

    protected onEditCompanyProfileClick() {
        this.ui.status.editProfile = true;
        this.item.tempUserData = Object.assign({}, this.item.userData);
        this.item.tempAccountData = Object.assign({}, this.item.accountData);
    }

    protected preventNonNumericalInput(event: any) {
        common.preventNonNumericalInput(event);
    }

    protected onCancelCompanyProfileClick() {
        this.resetError();
        this.ui.status.editProfile = false;
        this.item.userData = this.item.tempUserData;
        this.item.accountData = this.item.tempAccountData;
    }

    protected updateCompanyProfile() {
        this.resetError();
        if (!this.validateUpdateCompanyProfileAction()) {
            return;
        }
        let data = {
            firstname: this.item.userData.firstname,
            lastname: this.item.userData.lastname,
            company_name: this.item.accountData.company_name,
            company_address_line1: this.item.accountData.company_address_line1,
            company_address_line2: this.item.accountData.company_address_line2,
            company_city: this.item.accountData.company_city,
            company_province: this.item.accountData.company_province,
            company_country: this.item.accountData.company_country,
            company_zip: this.item.accountData.company_zip,
            company_phone1: this.item.accountData.company_phone1,
            company_phone2: this.item.accountData.company_phone2,
            company_contact_person: this.item.accountData.company_contact_person,
            contact_person_designation: this.item.accountData.contact_person_designation,
        };
        this.ui.status.postLoading.editProfile = true;
        trekService
            .updateProfileDetail(data)
            .then((res: any) => {
                this.item.userData = res.data.data;
                this.item.accountData = res.data.data.account_user.account;
                this.ui.status.editProfile = false;
                this.resetError();
                flashService.Success('Profile Updated', res.data.message);
            })
            .catch((error: any) => {
                common.sdCatchErr(error, this.ui.error.error_message).then(res => {
                    this.ui.error.error_message = res;
                });
            })
            .finally(() => {
                this.ui.status.postLoading.editProfile = false;
            });
    }

    protected validateUpdateCompanyProfileAction() {
        if (!this.item.userData.firstname) {
            Object.assign(this.ui.error.errors, {
                first_name: ['The first name field is required.']
            });
        }
        if (this.item.userData.firstname) {
            if (this.item.userData.firstname.match(/^[a-z]+$/i) === null) {
                Object.assign(this.ui.error.errors, {first_name: ['Please enter valid first name.']});
            }
        }
        if (!this.item.userData.lastname) {
            Object.assign(this.ui.error.errors, {
                last_name: ['The last name field is required.']
            });
        }
        if (this.item.userData.lastname) {
            if (this.item.userData.lastname.match(/^[a-z]+$/i) === null) {
                Object.assign(this.ui.error.errors, {last_name: ['Please enter valid last name.']});
            }
        }
        if (!this.item.accountData.company_name) {
            Object.assign(this.ui.error.errors, {
                company_name: ['The company name field is required.']
            });
        }
        if (this.item.accountData.company_country) {
            if (this.item.accountData.company_country.match(/^[a-z]+$/i) === null) {
                Object.assign(this.ui.error.errors, {country_name: ['Please enter valid country name.']});
            }
        }
        if (common.notEmpty(this.ui.error.errors)) {
            this.ui.error.has_error = true;
            return false;
        } else {
            return true;
        }
    }


    public resetError() {
        this.ui.error.errors = {};
        this.ui.error.has_error = false;
        this.ui.error.error_message = {};
    }
}
